module.exports = __webpack_public_path__ + "static/media/daycarePlayAreaIcon.6d6d241a.png";